var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      class: { "is-in-iframe": _vm.isInIframe },
      attrs: { id: "sidenav-layout" }
    },
    [
      _c(
        "nav",
        { staticClass: "sidenav" },
        [_c("ma-side-nav", { attrs: { items: _vm.dataUserRoutes } })],
        1
      ),
      _c(
        "div",
        { staticClass: "main" },
        [
          _c("transition", { attrs: { name: "fade", mode: "out-in" } }, [
            _c("div", { staticClass: "container" }, [
              _c("p", { staticClass: "black headline-large mg mg--b-4" }, [
                _c("span", [
                  _vm._v(_vm._s(_vm.$t("warrantyProps.moreInfoModal.title")))
                ])
              ]),
              _c("p", { staticClass: "headline-medium blueDark mg mg--b-3" }, [
                _vm._v(
                  _vm._s(
                    _vm.$t("warrantyProps.moreInfoModal.personalInfo.title")
                  )
                )
              ]),
              _c(
                "div",
                { staticClass: "grid" },
                [
                  _c("ma-input-text", {
                    attrs: {
                      type: "text",
                      name: "moreInfoName",
                      col: 2,
                      icon: "ico-donnes-du-dossier",
                      literal: _vm.$t(
                        "warrantyProps.moreInfoModal.personalInfo.name"
                      )
                    },
                    model: {
                      value: _vm.extraInfo.firstName,
                      callback: function($$v) {
                        _vm.$set(_vm.extraInfo, "firstName", $$v)
                      },
                      expression: "extraInfo.firstName"
                    }
                  }),
                  _c("ma-input-text", {
                    attrs: {
                      type: "text",
                      name: "moreInfoSurname",
                      col: 2,
                      icon: "ico-donnes-du-dossier",
                      literal: _vm.$t(
                        "warrantyProps.moreInfoModal.personalInfo.surname"
                      )
                    },
                    model: {
                      value: _vm.extraInfo.lastName,
                      callback: function($$v) {
                        _vm.$set(_vm.extraInfo, "lastName", $$v)
                      },
                      expression: "extraInfo.lastName"
                    }
                  }),
                  _c("ma-input-text", {
                    attrs: {
                      type: "text",
                      name: "moreInfoEmail",
                      col: 2,
                      icon: "globe",
                      literal: _vm.$t(
                        "warrantyProps.moreInfoModal.personalInfo.email"
                      )
                    },
                    model: {
                      value: _vm.extraInfo.email,
                      callback: function($$v) {
                        _vm.$set(_vm.extraInfo, "email", $$v)
                      },
                      expression: "extraInfo.email"
                    }
                  }),
                  _c("ma-input-btn", {
                    attrs: {
                      type: "btn",
                      name: "sinisterAddress",
                      col: 4,
                      options: _vm.validContractOptions,
                      literal: _vm.$t(
                        "warrantyProps.moreInfoModal.personalInfo.sinisterAddress"
                      ),
                      value: _vm.extraInfo.sinisterAddress,
                      selectFirst: false
                    },
                    on: {
                      change: function($event) {
                        ;[(_vm.extraInfo.sinisterAddress = $event)]
                      }
                    }
                  })
                ],
                1
              ),
              _c(
                "p",
                { staticClass: "headline-medium blueDark mg mg--b-3 mg--t-3" },
                [
                  _vm._v(
                    _vm._s(
                      _vm.$t("warrantyProps.moreInfoModal.contractInfo.title")
                    )
                  )
                ]
              ),
              _c(
                "div",
                { staticClass: "grid__row" },
                [
                  _c("ma-date-picker", {
                    staticClass: "input-date mg grid__cell-md-1",
                    attrs: {
                      type: "range",
                      icon: "calendar",
                      literal: _vm.$t(
                        "warrantyProps.moreInfoModal.contractInfo.date"
                      ),
                      dateMax: _vm.maxDate,
                      format: _vm.dateFormat,
                      handleChangeInput: _vm.handleChangeSinisterDate,
                      col: "1"
                    }
                  }),
                  _c("ma-input-text", {
                    attrs: {
                      type: "text",
                      name: "numPolice",
                      col: 1,
                      icon: "ico-donnes-du-dossier",
                      literal: _vm.$t(
                        "warrantyProps.moreInfoModal.contractInfo.police"
                      )
                    },
                    model: {
                      value: _vm.extraInfo.police,
                      callback: function($$v) {
                        _vm.$set(_vm.extraInfo, "police", $$v)
                      },
                      expression: "extraInfo.police"
                    }
                  }),
                  _c("ma-input-btn", {
                    attrs: {
                      type: "btn",
                      name: "validContract",
                      col: 4,
                      literal: _vm.$t(
                        "warrantyProps.moreInfoModal.contractInfo.isValid"
                      ),
                      options: _vm.validContractOptions,
                      value: _vm.extraInfo.validContract,
                      selectFirst: false
                    },
                    on: {
                      change: function($event) {
                        ;[(_vm.extraInfo.validContract = $event)]
                      }
                    }
                  }),
                  _c("ma-input-btn", {
                    attrs: {
                      type: "btn",
                      name: "scoreAsk",
                      col: 4,
                      options: _vm.scoreAskOptions,
                      literal: _vm.$t(
                        "warrantyProps.moreInfoModal.contractInfo.scoreAsk"
                      ),
                      value: _vm.extraInfo.scoreAsk,
                      selectFirst: false
                    },
                    on: {
                      change: function($event) {
                        ;[(_vm.extraInfo.scoreAsk = $event)]
                      }
                    }
                  })
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "grid__row grid--jc-between blueDark" },
                [
                  _c("ma-input-btn", {
                    attrs: {
                      type: "btn",
                      name: "franchiseGenerale",
                      col: 4,
                      options: _vm.franchiseOptions,
                      literal: _vm.$t(
                        "warrantyProps.moreInfoModal.contractInfo.franchiseGenerale"
                      ),
                      value: _vm.extraInfo.franchiseGenerale,
                      selectFirst: false,
                      disabled: _vm.extraInfo.franchiseMontantLibre != null,
                      "show-cancel": true
                    },
                    on: {
                      change: function($event) {
                        ;[(_vm.extraInfo.franchiseGenerale = $event)]
                      }
                    }
                  }),
                  _c("ma-input-number", {
                    attrs: {
                      type: "number",
                      name: "franchiseMontantLibre",
                      col: 1,
                      icon: "ico-montant",
                      literal: _vm.$t(
                        "warrantyProps.moreInfoModal.contractInfo.franchiseMontantLibre"
                      ),
                      min: _vm.franchiseMontantLibre.min,
                      max: _vm.franchiseMontantLibre.max,
                      disabled: _vm.extraInfo.franchiseGenerale != null
                    },
                    on: {
                      click: function($event) {
                        _vm.extraInfo.franchiseGenerale = null
                      }
                    },
                    model: {
                      value: _vm.extraInfo.franchiseMontantLibre,
                      callback: function($$v) {
                        _vm.$set(_vm.extraInfo, "franchiseMontantLibre", $$v)
                      },
                      expression: "extraInfo.franchiseMontantLibre"
                    }
                  })
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "grid__row" },
                [
                  _c("ma-input-checkbox", {
                    attrs: {
                      type: "checkbox",
                      name: "optionalValues",
                      literal: _vm.$t(
                        "warrantyProps.moreInfoModal.contractInfo.options"
                      ),
                      col: 4,
                      options: [
                        {
                          key: "optionRAN",
                          literal: _vm.$t(
                            "warrantyProps.moreInfoModal.contractInfo.ran"
                          )
                        },
                        {
                          key: "piscine",
                          literal: _vm.$t(
                            "warrantyProps.moreInfoModal.contractInfo.swimmingPool"
                          )
                        },
                        {
                          key: "exterieur",
                          literal: _vm.$t(
                            "warrantyProps.moreInfoModal.contractInfo.externalFittings"
                          )
                        }
                      ],
                      value: {
                        piscine: _vm.extraInfo.optionalValues.piscine,
                        exterieur: _vm.extraInfo.optionalValues.exterieur,
                        optionRAN: _vm.extraInfo.optionalValues.optionRAN
                      }
                    },
                    on: { change: _vm.handleMultipleCheckbox }
                  })
                ],
                1
              ),
              _c("p"),
              _c(
                "p",
                { staticClass: "headline-medium blueDark mg mg--b-3 mg--t-3" },
                [
                  _vm._v(
                    _vm._s(
                      _vm.$t("warrantyProps.moreInfoModal.verifications.title")
                    )
                  )
                ]
              ),
              _c(
                "div",
                { staticClass: "grid__row" },
                [
                  _c("ma-input-btn", {
                    attrs: {
                      type: "btn",
                      name: "currentClaim",
                      col: 4,
                      options: _vm.validContractOptions,
                      literal: _vm.$t(
                        "warrantyProps.moreInfoModal.verifications.beforeSinister"
                      ),
                      textTooltip: _vm.$t(
                        "warrantyProps.moreInfoModal.verifications.beforeSinisterTooltip"
                      ),
                      showTooltip: "",
                      value: _vm.extraInfo.currentClaim,
                      selectFirst: false
                    },
                    on: {
                      change: function($event) {
                        ;[(_vm.extraInfo.currentClaim = $event)]
                      }
                    }
                  }),
                  _c("ma-input-btn", {
                    attrs: {
                      type: "btn",
                      name: "litigationAlertAbsence",
                      col: 4,
                      options: _vm.validContractOptions,
                      literal: _vm.$t(
                        "warrantyProps.moreInfoModal.verifications.litigationAlertAbsence"
                      ),
                      value: _vm.extraInfo.litigationAlertAbsence,
                      selectFirst: false
                    },
                    on: {
                      change: function($event) {
                        ;[(_vm.extraInfo.litigationAlertAbsence = $event)]
                      }
                    }
                  }),
                  _c("ma-counter", {
                    staticClass: "grid__cell-md-1",
                    attrs: {
                      name: "gagNumber",
                      col: 1,
                      literal: _vm.$t(
                        "warrantyProps.moreInfoModal.verifications.GaG"
                      ),
                      textTooltip: _vm.$t(
                        "warrantyProps.moreInfoModal.verifications.indemnityName"
                      ),
                      value: _vm.extraInfo.gagNumber,
                      noMargin: "",
                      canReturnToZero: "",
                      fullSize: ""
                    },
                    on: {
                      newValue: function($event) {
                        ;[(_vm.extraInfo.gagNumber = $event)]
                      }
                    }
                  }),
                  _c("ma-counter", {
                    staticClass: "grid__cell-md-1",
                    attrs: {
                      name: "renNumber",
                      col: 1,
                      literal: _vm.$t(
                        "warrantyProps.moreInfoModal.verifications.ren"
                      ),
                      textTooltip: _vm.$t(
                        "warrantyProps.moreInfoModal.verifications.indemnityName"
                      ),
                      noMargin: "",
                      fullSize: "",
                      value: _vm.extraInfo.renNumber,
                      canReturnToZero: ""
                    },
                    on: {
                      newValue: function($event) {
                        ;[(_vm.extraInfo.renNumber = $event)]
                      }
                    }
                  })
                ],
                1
              ),
              _c("p"),
              _c(
                "p",
                { staticClass: "headline-medium blueDark mg mg--b-3 mg--t-3" },
                [
                  _vm._v(
                    _vm._s(
                      _vm.$t("warrantyProps.moreInfoModal.sinisterCause.title")
                    )
                  )
                ]
              ),
              _c(
                "div",
                { staticClass: "grid__row" },
                [
                  _c("ma-input-btn", {
                    staticClass: "radio-image",
                    attrs: {
                      type: "radio",
                      name: "sinisterCause",
                      col: 4,
                      buttonContentClass: "image-radio-content",
                      literal: _vm.$t(
                        "warrantyProps.moreInfoModal.sinisterCause.cause"
                      ),
                      options: _vm.moreInfoSinisterCauseOptions,
                      value: _vm.extraInfo.sinisterCause
                    },
                    on: {
                      change: function($event) {
                        ;[(_vm.extraInfo.sinisterCause = $event)]
                      }
                    }
                  })
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "grid__row" },
                [
                  _c("ma-input-btn", {
                    attrs: {
                      type: "btn",
                      name: "sinisterPlace",
                      col: 4,
                      options: _vm.sinisterPlaceOptions,
                      literal: _vm.$t(
                        "warrantyProps.moreInfoModal.sinisterCause.sinisterPlace"
                      ),
                      selectFirst: false,
                      value: _vm.extraInfo.sinisterPlace
                    },
                    on: {
                      change: function($event) {
                        ;[(_vm.extraInfo.sinisterPlace = $event)]
                      }
                    }
                  }),
                  _c("ma-input-btn", {
                    attrs: {
                      type: "btn",
                      name: "damagePlace",
                      col: 4,
                      options: _vm.damagePlaceOptions,
                      literal: _vm.$t(
                        "warrantyProps.moreInfoModal.sinisterCause.damagePlace"
                      ),
                      selectFirst: false,
                      value: _vm.extraInfo.damagePlace
                    },
                    on: {
                      change: function($event) {
                        ;[(_vm.extraInfo.damagePlace = $event)]
                      }
                    }
                  }),
                  _c("ma-input-btn", {
                    attrs: {
                      type: "btn",
                      name: "causeRepaired",
                      col: 4,
                      options: _vm.causeRepairedOptions,
                      literal: _vm.$t(
                        "warrantyProps.moreInfoModal.sinisterCause.causeRepaired"
                      ),
                      selectFirst: false,
                      value: _vm.extraInfo.causeRepaired
                    },
                    on: {
                      change: function($event) {
                        ;[(_vm.extraInfo.causeRepaired = $event)]
                      }
                    }
                  }),
                  _c("ma-input-btn", {
                    attrs: {
                      type: "btn",
                      name: "thirdPartyInvolved",
                      col: 4,
                      options: _vm.validContractOptions,
                      literal: _vm.$t(
                        "warrantyProps.moreInfoModal.sinisterCause.thirdPartyInvolved"
                      ),
                      selectFirst: false,
                      value: _vm.extraInfo.thirdPartyInvolved
                    },
                    on: {
                      change: function($event) {
                        ;[(_vm.extraInfo.thirdPartyInvolved = $event)]
                      }
                    }
                  })
                ],
                1
              ),
              _c("p"),
              _c(
                "button",
                {
                  staticClass: "btn secondaryBlue mg mg--r-2",
                  attrs: { name: "goBack" },
                  on: { click: _vm.warrantyBack }
                },
                [_vm._v(_vm._s(_vm.$t("actions.cancel")))]
              ),
              _c(
                "button",
                {
                  staticClass:
                    "btn mainBlue grid__cell-md-4 mg mg--r-2 mg--t-2",
                  attrs: {
                    name: "continue",
                    disabled: !_vm.isMoreInfoSendButtonEnabled
                  },
                  on: { click: _vm.sendAditionalInfo }
                },
                [_vm._v(_vm._s(_vm.$t("warrantyProps.moreInfoModal.send")))]
              )
            ])
          ])
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }